var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatNoMessagesIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "185px",
    height: "143px",
    viewBox: "0 0 185 143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EE5CA791-4BFC-4DBC-9654-F2AD7DFF74B1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[[D]]-Business",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-no-messages",
    transform: "translate(-719.000000, -383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    transform: "translate(657.000000, 383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(62.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#ABBFC6",
    x: 42,
    y: 113,
    width: 86,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#ABBFC6",
    x: 42,
    y: 125,
    width: 86,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#ABBFC6",
    x: 42,
    y: 137,
    width: 32,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bot-Copy-2",
    transform: "translate(0.000000, 107.000000)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.845805,27.9402299 L16.7800998,31.3489612 C15.9996026,32.2170129 14.5491502,32.2170129 13.768653,31.3489612 L10.7029478,27.9402299 L19.845805,27.9402299 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.274434,25.1428571 C9.38333586,25.1428571 4.60761636,20.3673382 4.60761636,14.476115 C4.60761636,8.58526921 9.38333586,3.80952381 15.274434,3.80952381 C21.1655321,3.80952381 25.9409497,8.58526921 25.9409497,14.476115 C25.9409497,20.3673382 21.1655321,25.1428571 15.274434,25.1428571 M15.2744075,0 C6.85870675,0 0.0362811791,6.48129105 0.0362811791,14.4761313 C0.0362811791,22.4713856 6.85870675,28.952381 15.2744075,28.952381 C23.6901083,28.952381 30.5124717,22.4713856 30.5124717,14.4761313 C30.5124717,6.48129105 23.6901083,0 15.2744075,0",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8571429,14.4761905 C22.8571429,16.5801259 21.1516152,18.2857143 19.047619,18.2857143 C16.9436836,18.2857143 15.2380952,16.5801259 15.2380952,14.4761905 C15.2380952,12.3724979 16.9436836,10.6666667 19.047619,10.6666667 C21.1516152,10.6666667 22.8571429,12.3724979 22.8571429,14.4761905",
    id: "Fill-7-Copy"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#ABBFC6",
    x: 62,
    y: 65,
    width: 86,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#ABBFC6",
    x: 86,
    y: 77,
    width: 62,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bot-Copy",
    transform: "translate(154.000000, 60.000000)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.845805,27.9402299 L16.7800998,31.3489612 C15.9996026,32.2170129 14.5491502,32.2170129 13.768653,31.3489612 L10.7029478,27.9402299 L19.845805,27.9402299 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.274434,25.1428571 C9.38333586,25.1428571 4.60761636,20.3673382 4.60761636,14.476115 C4.60761636,8.58526921 9.38333586,3.80952381 15.274434,3.80952381 C21.1655321,3.80952381 25.9409497,8.58526921 25.9409497,14.476115 C25.9409497,20.3673382 21.1655321,25.1428571 15.274434,25.1428571 M15.2744075,0 C6.85870675,0 0.0362811791,6.48129105 0.0362811791,14.4761313 C0.0362811791,22.4713856 6.85870675,28.952381 15.2744075,28.952381 C23.6901083,28.952381 30.5124717,22.4713856 30.5124717,14.4761313 C30.5124717,6.48129105 23.6901083,0 15.2744075,0",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7619048,12.952381 C16.7619048,15.0563164 15.0563771,16.7619048 12.952381,16.7619048 C10.8484455,16.7619048 9.14285714,15.0563164 9.14285714,12.952381 C9.14285714,10.8486884 10.8484455,9.14285714 12.952381,9.14285714 C15.0563771,9.14285714 16.7619048,10.8486884 16.7619048,12.952381",
    id: "Fill-7-Copy"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#ABBFC6",
    x: 42,
    y: 5,
    width: 86,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#ABBFC6",
    x: 42,
    y: 17,
    width: 86,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#ABBFC6",
    x: 42,
    y: 29,
    width: 32,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bot-Copy-3",
    transform: "translate(0.000000, 0.000000)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.845805,28.0036638 L16.7800998,31.3591337 C15.9996026,32.2136221 14.5491502,32.2136221 13.768653,31.3591337 L10.7029478,28.0036638 L19.845805,28.0036638 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.274434,25.25 C9.38333586,25.25 4.60761636,20.5490985 4.60761636,14.7499257 C4.60761636,8.95112437 9.38333586,4.25 15.274434,4.25 C21.1655321,4.25 25.9409497,8.95112437 25.9409497,14.7499257 C25.9409497,20.5490985 21.1655321,25.25 15.274434,25.25 M15.2744075,0.5 C6.85870675,0.5 0.0362811791,6.88002088 0.0362811791,14.7499418 C0.0362811791,22.6202702 6.85870675,29 15.2744075,29 C23.6901083,29 30.5124717,22.6202702 30.5124717,14.7499418 C30.5124717,6.88002088 23.6901083,0.5 15.2744075,0.5",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "+",
    fillRule: "nonzero",
    points: "19.2838095 7.44 19.2838095 10.68 22.4438095 10.68 22.4438095 14.02 19.2838095 14.02 19.2838095 17.28 15.7438095 17.28 15.7438095 14.02 12.6038095 14.02 12.6038095 10.68 15.7438095 10.68 15.7438095 7.44"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNoMessagesIllustration);
export default __webpack_public_path__ + "static/media/chatNoMessagesIllustration.62fafd2d44093d913141ea62e30f91a7.svg";
export { ForwardRef as ReactComponent };